import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import TUIRoomCore, { ETUIRoomEvents } from '../../tui-room-core';
import IconButton from '../common/IconButton.vue';
import { SettingMode } from '../../../constants/render';
import AudioSettingTab from '../base/AudioSettingTab.vue';
import VideoSettingTab from '../base/VideoSettingTab.vue';
import AudioIcon from '../base/AudioIcon.vue';
import { useRoomStore } from '../../../stores/room';
import { storeToRefs } from 'pinia';
import { ICON_NAME } from '../../../constants/icon';


export default /*#__PURE__*/_defineComponent({
  __name: 'StreamPreview',
  setup(__props, { expose }) {

const roomStore = useRoomStore();
const { localStream } = storeToRefs(roomStore);

expose({
  getRoomParam,
});

const tuiRoomParam = {
  isOpenCamera: true,
  isOpenMicrophone: true,
  defaultCameraId: '',
  defaultMicrophoneId: '',
  defaultSpeakerId: '',
};

const streamPreviewRef = ref();
const loading = ref(true);

const isMicMuted = ref(false);
const isCameraMuted = ref(false);

const cameraIconName = computed(() => (isCameraMuted.value ? ICON_NAME.CameraOff : ICON_NAME.CameraOn));

function toggleMuteAudio() {
  isMicMuted.value = !isMicMuted.value;
  tuiRoomParam.isOpenMicrophone = !isMicMuted.value;
}

function toggleMuteVideo() {
  isCameraMuted.value = !isCameraMuted.value;
  tuiRoomParam.isOpenCamera = !isCameraMuted.value;
  if (isCameraMuted.value) {
    TUIRoomCore.stopCameraPreview();
  } else {
    TUIRoomCore.startCameraPreview(streamPreviewRef.value);
  }
}

function getRoomParam() {
  tuiRoomParam.defaultCameraId = roomStore.currentCameraId;
  tuiRoomParam.defaultMicrophoneId = roomStore.currentMicrophoneId;
  tuiRoomParam.defaultSpeakerId = roomStore.currentSpeakerId;
  return tuiRoomParam;
}

const onUserVoiceVolume = (eventInfo: []) => {
  roomStore.setAudioVolume(eventInfo);
};

onMounted(async () => {
  const cameraList = await TUIRoomCore.getCameraList();
  const microphoneList = await TUIRoomCore.getMicrophoneList();
  roomStore.setCurrentCameraId(cameraList[0].deviceId);
  roomStore.setCurrentMicrophoneId(microphoneList[0].deviceId);
  roomStore.setCurrentSpeakerId(microphoneList[0].deviceId);
  TUIRoomCore.setCurrentCamera(cameraList[0].deviceId);
  TUIRoomCore.setCurrentMicrophone(microphoneList[0].deviceId);
  await TUIRoomCore.startCameraPreview(streamPreviewRef.value);
  TUIRoomCore.enableAudioVolumeEvaluation(100);
  await TUIRoomCore.startMicrophone();
  loading.value = false;
  TUIRoomCore.on(ETUIRoomEvents.onUserVoiceVolume, onUserVoiceVolume);
});

onBeforeUnmount(async () => {
  await TUIRoomCore.stopCameraPreview();
  await TUIRoomCore.stopMicrophone();
  TUIRoomCore.off(ETUIRoomEvents.onUserVoiceVolume, onUserVoiceVolume);
});

// ----- 处理音视频设备设置
const isSettingOpen = ref(false);
const settingTitle = ref('');
const settingTab = ref('');

// 处理音频设备设置
function handleMicSetting() {
  isSettingOpen.value = true;
  settingTitle.value = '麦克风设置';
  settingTab.value = 'audio';
}

// 处理视频设备设置
function handleCameraSetting() {
  isSettingOpen.value = true;
  settingTitle.value = '摄像头设置';
  settingTab.value = 'video';
}

function handleDrawerClose(done: any) {
  settingTab.value = '';
  done();
}


return { __sfc: true,roomStore, localStream, tuiRoomParam, streamPreviewRef, loading, isMicMuted, isCameraMuted, cameraIconName, toggleMuteAudio, toggleMuteVideo, getRoomParam, onUserVoiceVolume, isSettingOpen, settingTitle, settingTab, handleMicSetting, handleCameraSetting, handleDrawerClose, IconButton, SettingMode, AudioSettingTab, VideoSettingTab, AudioIcon }
}

})